module.exports = __webpack_public_path__ + "static/img/home-hero-mobile-bg-02.7b4039c.svg";